module.exports = __webpack_public_path__ + "static/media/3_Foiled_01.f0f636cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Papers/3_Foiled_01.jpg
// module id = 1706
// module chunks = 0